import { useContext } from "react";
import { CommonComponentContext } from "../utils/CommonComponentContext";

export default function useClientConfig() {
    const commonContext = useContext(CommonComponentContext);
    return commonContext.clientConfig;
}